<template>
	<div style="overflow-y: hidden;">
    <div class="col-md-12" style="overflow-y: hidden;">
      <b-form-group id="caclulation_base-group" class="half-width mr1 required-field" label="Calculation Based On" label-for="caclulation_base"> <!-- Mustafijur: 24-06-2026: Removed space -->
        <b-form-select id="caclulation_base" name="caclulation_base" v-model="reasondetails.type" v-validate="{ required: true }" :options="base_options" :state="validateState('caclulation_base')" aria-describedby="caclulation_base-feedback" data-vv-as="Calculation Base Type"></b-form-select>
        <b-form-invalid-feedback id="caclulation_base-feedback">{{ veeErrors.first('caclulation_base') }}</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="operator-group" class="half-width mr1 required-field" label="Operator to be used" label-for="operator">
        <b-form-select id="operator" name="operator" v-model="reasondetails.operator" v-validate="{ required: true }" :options="operators" :state="validateState('operator')" aria-describedby="operator-feedback" data-vv-as="Operator"></b-form-select>
        <b-form-invalid-feedback id="operator-feedback">{{ veeErrors.first('operator') }}</b-form-invalid-feedback>
      </b-form-group>
    </div>
       
	  
	    <hr class="ml-3">
	    
	    <div class="col-md-12" style="overflow-y: hidden;">
	    	<table class="table dataTable">
		    <thead>
		        <tr class="table-head ">
              <template v-if="reasondetails.type == 1 || reasondetails.type == 2">
                <td colspan="2" class="bg-white"></td>
              </template>
              <template v-else-if="reasondetails.type == 3">
                <td colspan="3" class="bg-white"></td>
              </template>
              <template v-else>
                <td class="bg-white"></td>
              </template>                                        
		            <td colspan="2" class="first-row">Employee</td>                                                                       
                <td colspan="2" class="first-row">Employer</td> <!-- Rejwan: 23-04-2025 Spelling correction -->
		            <td class="bg-white"></td>
		        </tr>
		        <tr class="table-head">
		            <td>Operator</td>
                <template v-if="reasondetails.type == 1 || reasondetails.type == 3">
                  <td>Service Period (Months)</td>
                </template>
                <template v-if="reasondetails.type == 2 || reasondetails.type == 3">
                  <td>Fund Membership Period (Months)</td>
                </template>
		            
		            
		            <td>Contribution (%)</td>
		            <td>Profit (%)</td>
		            <td>Contribution (%)</td>
		            <td>Profit (%)</td>
		            <td>Actions</td>
		        </tr>
		    </thead>
        <tbody>
		    	<tr class="hover-bg table-row mx-2" v-for="(slab, n) in slabs.filter(s => s.is_default != 1)" :key=slab.id>
	    		  <td class="operator_td">
              
              {{ showOperator(reasondetails.operator) }}
	    		    
	    		  </td>
            <template v-if="reasondetails.type == 1 || reasondetails.type == 3">
              <td> 
                <div class="d-flex align-items-center">	    
                  <template v-if="n == 0">
                    <b-form-group :id="n+'_service_month-group'" class="required-field" :label-for="n+'_service_month'">
                      <b-form-input :id="n+'_service_month'" :state="validateState(n+'_service_month')" :name="n+'_service_month'" v-model="slab.service_month" v-validate="{ required: true,numeric:true}" :aria-describedby="n+'_service_month-feedback'" data-vv-as="Service Period" ></b-form-input>
                      <b-form-invalid-feedback :id="n+'_service_month-feedback'">{{ veeErrors.first(n+'_service_month') }}</b-form-invalid-feedback>
                    </b-form-group>
                  </template>	
                  <template v-else>
                    <b-form-group :id="n+'_service_month-group'" class="required-field" :label-for="n+'_service_month'">
                      <b-form-input :id="n+'_service_month'" :state="validateState(n+'_service_month')" :name="n+'_service_month'" v-model="slab.service_month" v-validate="{ required: true,numeric:true,min_value:getMinValue(slabs[n-1].service_month)}" :aria-describedby="n+'_service_month-feedback'" data-vv-as="Service Period" ></b-form-input>
                      <b-form-invalid-feedback :id="n+'_service_month-feedback'">{{ veeErrors.first(n+'_service_month') }}</b-form-invalid-feedback>
                    </b-form-group>
                  </template>
                  
                </div>
              </td>
            </template>
            <template v-if="reasondetails.type == 2 || reasondetails.type == 3">
              <td>
                <div class="d-flex align-items-center">
                  <template v-if="n == 0">
                    <b-form-group :id="n+'membership_month-group'" class="required-field" :label-for="n+'membership_month'">
                      <b-form-input :id="n+'membership_month'" :state="validateState(n+'membership_month')" :name="n+'membership_month'" v-model="slab.membership_month" v-validate="{ required: true,numeric:true}" :aria-describedby="n+'membership_month-feedback'" data-vv-as="Membership Period" ></b-form-input>
                      <b-form-invalid-feedback :id="n+'membership_month-feedback'">{{ veeErrors.first(n+'membership_month') }}</b-form-invalid-feedback>
                    </b-form-group>
                  </template>
                  <template v-else>
                    <b-form-group :id="n+'membership_month-group'" class="required-field" :label-for="n+'membership_month'">
                    <b-form-input :id="n+'membership_month'" :state="validateState(n+'membership_month')" :name="n+'membership_month'" v-model="slab.membership_month" v-validate="{ required: true,numeric:true,min_value:getMinValue(slabs[n-1].membership_month)}" :aria-describedby="n+'membership_month-feedback'" data-vv-as="Membership Period" ></b-form-input>
                    <b-form-invalid-feedback :id="n+'membership_month-feedback'">{{ veeErrors.first(n+'membership_month') }}</b-form-invalid-feedback>
                  </b-form-group>
                  </template>
                </div> 
              </td>
            </template>
	    		  <td>
              <b-form-group :id="n+'employee_contr-group'" class="required-field" :label-for="n+'employee_contr'">
                <b-form-input :id="n+'employee_contr'" :state="validateState(n+'employee_contr')" :name="n+'employee_contr'" v-model="slab.employee_contr" v-validate="{ required: true,numeric:true,min_value:0,max_value:100}" :aria-describedby="n+'employee_contr-feedback'" data-vv-as="Employee Contribution" ></b-form-input>
                <b-form-invalid-feedback :id="n+'employee_contr-feedback'">{{ veeErrors.first(n+'employee_contr') }}</b-form-invalid-feedback>
              </b-form-group> 
            </td>
	    		  <td>
              <b-form-group :id="n+'employee_profit-group'" class="required-field" :label-for="n+'employee_profit'">
                <b-form-input :id="n+'employee_profit'" :state="validateState(n+'employee_profit')" :name="n+'employee_profit'" v-model="slab.employee_profit" v-validate="{ required: true,numeric:true,min_value:0,max_value:100}" :aria-describedby="n+'employee_profit-feedback'" data-vv-as="Employee Profit" ></b-form-input>
                <b-form-invalid-feedback :id="n+'employee_profit-feedback'">{{ veeErrors.first(n+'employee_profit') }}</b-form-invalid-feedback>
              </b-form-group> 
            </td>
	    		  <td>
              <b-form-group :id="n+'employer_contr-group'" class="required-field" :label-for="n+'employer_contr'">
                <b-form-input :id="n+'employer_contr'" :state="validateState(n+'employer_contr')" :name="n+'employer_contr'" v-model="slab.employer_contr" v-validate="{ required: true,numeric:true,min_value:0,max_value:100}" :aria-describedby="n+'employer_contr-feedback'" data-vv-as="Employer Contribution" ></b-form-input>
                <b-form-invalid-feedback :id="n+'employer_contr-feedback'">{{ veeErrors.first(n+'employer_contr') }}</b-form-invalid-feedback>
              </b-form-group> 
            </td>
	    		  <td>
              <b-form-group :id="n+'employer_profit-group'" class="required-field" :label-for="n+'employer_profit'">
                <b-form-input :id="n+'employer_profit'" :state="validateState(n+'employer_profit')" :name="n+'employer_profit'" v-model="slab.employer_profit" v-validate="{ required: true,numeric:true,min_value:0,max_value:100}" :aria-describedby="n+'employer_profit-feedback'" data-vv-as="Employer Profit" ></b-form-input>
                <b-form-invalid-feedback :id="n+'employer_profit-feedback'">{{ veeErrors.first(n+'employer_profit') }}</b-form-invalid-feedback>
              </b-form-group> 
            </td>
	    		  <td><b-icon icon="trash-fill" aria-hidden="true" font-scale="1.5" @click="deleteRow(n)"></b-icon></td>
		    	</tr>
          <tr class="hover-bg table-row mx-2 remainin_tenure">
           
            <template v-if="reasondetails.type == 1 || reasondetails.type == 2">
              <td colspan="2">Remaining Tenure</td>
            </template>
            <template v-else-if="reasondetails.type == 3">
              <td colspan="3">Remaining Tenure</td>
            </template>
            <template v-else>
              <td >Remaining Tenure</td>
            </template>           
	    		 
	    		  <td>
              <b-form-input v-model="default_slab.employee_contr" :state="validateState('employee_contr')" name="employee_contr" v-validate="{ required: true,numeric:true,min_value:0,max_value:100}" data-vv-as="Employee Contribution"></b-form-input>
              <b-form-invalid-feedback id="employee_contr-feedback">{{ veeErrors.first('employee_contr') }}</b-form-invalid-feedback>
            </td>

	    		  <td>
              <b-form-input v-model="default_slab.employee_profit" :state="validateState('employee_profit')" name="employee_profit" v-validate="{ required: true,numeric:true,min_value:0,max_value:100}" data-vv-as="Employee Profit"></b-form-input>
              <b-form-invalid-feedback id="employee_profit-feedback">{{ veeErrors.first('employee_profit') }}</b-form-invalid-feedback>
            </td>
            
	    		  <td>
              <b-form-input v-model="default_slab.employer_contr" :state="validateState('employer_contr')" name="employer_contr" v-validate="{ required: true,numeric:true,min_value:0,max_value:100}" data-vv-as="Employer Contribution"></b-form-input>
              <b-form-invalid-feedback id="employer_contr-feedback">{{ veeErrors.first('employer_contr') }}</b-form-invalid-feedback>
            </td>

	    		  <td>
              <b-form-input v-model="default_slab.employer_profit" :state="validateState('employer_profit')" name="employer_profit" v-validate="{ required: true,numeric:true,min_value:0,max_value:100}" data-vv-as="Employer Profit"></b-form-input>
              <b-form-invalid-feedback id="employer_profit-feedback">{{ veeErrors.first('employer_profit') }}</b-form-invalid-feedback>
            </td>
          </tr>
		    </tbody>
	    	</table>
	    	
	    	<div class="m-4">                                                      
		    <b-button type="button" variant="primary" class="" @click="addRow">Add Slabs</b-button> <!-- Mustafijur: 24-06-2026: variant: primary, removed class custom-wizard-btn-->
		    
		    <b-button type="button" variant="primary" class="" @click="saveReasonSlabs">Save</b-button> <!-- Mustafijur: 24-06-2026: variant: primary, removed class custom-wizard-btn-->
		</div>
	    
	    </div>
	</div>

</template>

<script>
    export default{
        props: ['reason'],
        data(){
            return {
                operators: [
                   { value: null, text: "Please Select" },
                   { value: 0, text: "Less Than" },
                   { value: 1, text: "Equal or Less Than" },                   
               ],
               reasondetails:{
                type:null, 
                operator:null, 
               },
               status: [                  
                        { value: "0", text: "Disabled" },
                        { value: "1", text: "Enable" },
                      ],

              base_options: [                  
                { value: null, text: "Please Select" },
                { value: 1, text: "Service Period" },
                { value: 2, text: "PF Membership Period" },
                { value: 3, text: "Both Service and PF Membership Period" },
              ],
                      
              slabs: [],  
              disable_remaining:true,
              url : this.$api_url+'/pf/advance-policy-reason-slab',
              default_slab: {
                  employee_contr: 100,
                  employee_profit: 100,
                  employer_contr: 100,
                  employer_profit: 100
              },
            }
        },
        methods:{
            getMinValue(value)
            {
              let c = parseInt(value) + 1;
              return c;
            },
            showOperator(value)
            {
                // Find the object with the given value
                const reason = this.operators.find(item => item.value == value);
                // const reason = this.reasondetails.operator.find(item => item.value === value);
                
                // Return the text if found, otherwise return a default message
                return reason ? reason.text : "Reason not found";
            },
            deleteRow(index){

                this.slabs.splice(index, 1);
            },
            addRow: function () {
                
                this.slabs.push(
                  {
                    operator:null,service_month:0,membership_month:0,employee_contr:0,employee_profit:0,employer_contr:0,employer_profit:0,
                  }
                );
            },
            
          getReasons: function()
          {            
              if(!this.checkNet()) return false;
              let currentObj = this;
              axios.get(this.$api_url+'/pf/advance-policy-reason').then(function(response){
                this.reasondetails = response.data;                 
                
              }.bind(this)).catch(function (error){ currentObj.serverError(error);});
          },
          getReasonSlabs: function()
          {            
              if(!this.checkNet()) return false;
              let currentObj = this;
              
              axios.get(this.url ).then(function(response){
                                  
                this.slabs = response.data.filter(d => d.is_default !== 1);
                const data = response.data.find(s => s.is_default === 1);

                if (data) {
                    this.default_slab = {
                        employee_contr: data.employee_contr,
                        employee_profit: data.employee_profit,
                        employer_contr: data.employer_contr,
                        employer_profit: data.employer_profit
                    };
                }
                // console.log('slabs', this.slabs);
                // this.default_slab = this.slabs.filter(s => s.is_default == 1);                 
                
              }.bind(this)).catch(function (error){ currentObj.serverError(error);});
          },
          saveReasonSlabs: function()
          {            
              if(!this.checkNet()) return false;
              
              this.$validator.validateAll().then(result => {
                  if (!result) {
                      return;
                  }

                  let currentObj = this;
                  console.log(this.slabs, this.reasondetails);
                  axios.post(this.url, {slabs: this.slabs,reasondetails: this.reasondetails, defaultSlab: this.default_slab})
                    .then(function (response) 
                    {
                      
                      this.$bvToast.toast('Saved!', {
                              title: `Success`,
                              variant: 'success',
                              solid: true
                          });
                      
                        
                    }.bind(this))
                    .catch(function (error) 
                    {                          
                      this.showoverlay = false;                        
                      currentObj.serverError(error);
                    });

                });
              
          },
           
        },
        created: function(){
          
          this.getReasons();
          this.getReasonSlabs();
          
      },
    }
</script>
<style>
.operator_td {
	width: 179px;
} 
</style>